import { Transfer } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

function Manage({ classList }) {
  const [mockData, setMockData] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);
  const transferData = classList.map((item) => ({
    key: item?.workflow_id,
    title: item?.workflow_name,
    description: item?.workflow_id,
  }));
  useEffect(() => {
    setMockData(transferData);
  }, []);
  const handleChange = (newTargetKeys) => {
    setTargetKeys(newTargetKeys);
  };

  return (
    <Transfer
      className="auto-approve"
      dataSource={mockData}
      showSearch
      titles={["Document Classes", "Auto-Approved Document Classes"]}
      targetKeys={targetKeys}
      onChange={handleChange}
      render={(item) => item.title}
    />
  );
}

Manage.propTypes = {
  classList: PropTypes.array,
};

export { Manage };
